import React from 'react';
import { motion } from 'framer-motion';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Skilmálar</h1>
          
          <div className="bg-white rounded-2xl p-8 shadow-sm prose max-w-none">
            <p><strong>Almennir skilmálar um þjónustu</strong></p>
<p>Allri þjónustu sem veitt er af Novamedia ehf. fylgja eftirfarandi skilmálar. Með því að nýta þjónustu okkar samþykkir þú þessa skilmála og skuldbindur þig til að fylgja þeim.</p>
<p>&nbsp;</p>
<p><strong>Tímagjald og þjónustusamningar</strong></p>
<p>Allri þjónustu sem veitt er af Novamedia ehf. er reiknað eftir tímagjaldi, nema annað sé samið um. Tímagjaldið okkar er 14.950 kr. á klukkustund (án vsk). Afsláttur af tímagjaldi er veittur samkvæmt þeim þjónustusamningi sem viðkomandi fyrirtæki er skráð í. Verð á þjónustusamningum er í samræmi við gildandi verðskrá.</p>
<p>Öll viðbótarverk sem ekki eru hluti af upphaflegum samningi eru rukkuð í samræmi við tímaskýrslu.</p>
<p>Kaup á ljósmyndum eða „stock“ efni eru ekki innifalin í verðáætlun nema sérstaklega sé tekið fram.</p>
<p>&nbsp;</p>
<p><strong>Reikningar og greiðslur</strong></p>
<p>Við sendum kröfur í fyrirtækja- eða heimabanka viðskiptavina. Eindagi er almennt settur 7-10 dögum frá útgáfudegi reiknings. Viðskiptavinir bera ábyrgð á að greiða kröfur innan eindaga. Vanskil eða seinkun á greiðslu geta leitt til viðbótarálagningar.</p>
<p>Verklok teljast þegar vefsetrið er tilbúið til efnisinnsetningar, og innheimta mánaðargjalda hefst við verklok. Mánaðargjöld eru greidd fyrirfram.</p>
<p>Við áskiljum okkur rétt til að stöðva þjónustu tímabundið ef ekki hefur verið greitt fyrir veitta þjónustu innan eindaga.</p>
<p>&nbsp;</p>
<p><strong>Uppsagnir og uppsagnafrestur</strong></p>
<p>Allir þjónustusamningar sem gerðir eru við Novamedia ehf. hafa lágmarks uppsagnarfrest upp á 3 mánuði. Uppsagnafrestur gildir ekki fyrstu 12 mánuði frá undirritun samnings og þjónustusamningur er þar með óuppsegjanlegur á því tímabili. Að loknum þessum 12 mánuðum geta báðir aðilar sagt upp þjónustusamningi með 3 mánaða fyrirvara. Uppsögn skal vera skrifleg og miðast við mánaðarmót.</p>
<p>Ef viðskiptavinur óskar eftir uppsögn samnings eða þjónustu áður en 12 mánuðir eru liðnir, er samningurinn áfram í gildi þar til 12 mánaða tímabilið er lokið.</p>
<p>&nbsp;</p>
<p><strong>Trúnaður</strong></p>
<p>Samningur þessi og tengd skjöl eru trúnaðarmál. Aðilar skulu virða sem trúnaðarmál allar upplýsingar sem þeir kunna að öðlast í samstarfinu um viðskiptavini, viðskiptahætti eða önnur viðkvæm gögn gagnaðila.</p>
<p>&nbsp;</p>
<p><strong>Skilmálar varðandi hýsingar og virkni</strong></p>
<p>Gagnagrunnur og vefsetur verður vistað á vefþjónum Novamedia ehf. Öll virkni umfram venjulega virkni er eign Novamedia ehf., og er verkkaupa óheimilt að selja, leigja eða afhenda þessa virkni þriðja aðila án skriflegs leyfis.</p>
<p>Útlit vefsins er eign verkkaupa og honum er heimilt að nýta það í önnur kynningarefni eða auglýsingar. Hins vegar gildir um það sæmdarréttur, líkt og um önnur hugverk.</p>
<p>&nbsp;</p>
<p><strong>Takmarkanir á ábyrgð</strong></p>
<p>Novamedia ehf. ber ekki ábyrgð á töfum, skaða, niðritíma eða svartíma sem verður vegna rangrar notkunar hugbúnaðar eða inngripa frá aðilum öðrum en starfsmönnum Novamedia. Novamedia ehf. ber enga ábyrgð á gæðum eða nothæfni vélbúnaðar, gagna eða efnis sem verkkaupi leggur til né á afleiddu tjóni eða hagnaðarmissi.</p>
<p>Bætur sem Novamedia ehf. kann að þurfa að greiða vegna ábyrgðar geta aldrei orðið hærri en nemur þeirri upphæð sem verkkaupi greiðir í stofnkostnað og ársleigu.</p>
<p>&nbsp;</p>
<p><strong>Breytingar á skilmálum</strong></p>
<p>Við hjá Novamedia ehf. áskiljum okkur rétt til að uppfæra eða breyta þessum skilmálum. Allar breytingar verða tilkynntar viðskiptavinum með a.m.k. 30 daga fyrirvara.</p>
<p>Hafðu samband</p>
<p>&nbsp;</p>
<p>Ef þú hefur einhverjar spurningar varðandi þessa skilmála eða hvernig þeir hafa áhrif á þína þjónustu, vinsamlegast hafðu samband við okkur í gegnum tölvupóst á hallo@vefsida.is eða hringdu í síma 537-7990.</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Terms;